import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=34d710b6"
import script from "./ModalCadastro.vue?vue&type=script&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports